import { render, staticRenderFns } from "./BaseLoader3.vue?vue&type=template&id=e63e0ce0&scoped=true&"
import script from "./BaseLoader3.vue?vue&type=script&lang=js&"
export * from "./BaseLoader3.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoader3.vue?vue&type=style&index=0&id=e63e0ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63e0ce0",
  null
  
)

export default component.exports